import RoundRectangle from '../../../plugins/gameobjects/shape/roundrectangle/RoundRectangle.js';
export default RoundRectangle;